import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiUser, FiBriefcase, FiCheck, FiArrowRight } from 'react-icons/fi';

const FeaturesSplit = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom space-y-24">
        
        {/* Bewerber Section - Gastronomie / Service */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="order-2 md:order-1 relative rounded-2xl overflow-hidden aspect-square md:aspect-[4/3] shadow-2xl"
          >
            {/* IMAGE: Attraktive Kellnerin in einem Restaurant */}
            <img 
              src="https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" 
              alt="Attraktive Kellnerin im Restaurant" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent"></div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="order-1 md:order-2 space-y-6"
          >
            <div className="w-12 h-12 bg-teal-50 rounded-xl flex items-center justify-center text-teal-600 mb-4">
              <SafeIcon icon={FiUser} className="text-2xl" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold">Du suchst einen Nebenjob? Wir helfen dir dabei.</h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              Du möchtest nebenbei Geld verdienen, aber keine komplizierten Bewerbungsprozesse durchlaufen? Bei Nebenjob Nord kannst du dich einfach registrieren und passende Jobs finden.
            </p>
            <ul className="space-y-3">
              {[
                'Flexible Nebenjobs und Minijobs',
                'Einfache Bewerbung ohne langes Anschreiben',
                'Passende Jobvorschläge nach deinen Angaben',
                'Auch Home-Office-Jobs möglich'
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-teal-100 flex items-center justify-center text-teal-600 flex-shrink-0">
                    <SafeIcon icon={FiCheck} className="text-xs" />
                  </span>
                  <span className="text-slate-700">{item}</span>
                </li>
              ))}
            </ul>
            <div className="pt-4">
              <Link to="/bewerber" className="btn-primary group">
                Kostenlos bewerben
                <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </motion.div>
        </div>

        {/* Unternehmen Section - Reinigung / Service */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <div className="w-12 h-12 bg-slate-100 rounded-xl flex items-center justify-center text-slate-900 mb-4">
              <SafeIcon icon={FiBriefcase} className="text-2xl" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold">Sie suchen Aushilfen oder Minijobber?</h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              Ob kurzfristige Unterstützung, regelmäßige Aushilfen oder flexible Mitarbeiter für einfache Tätigkeiten: Nebenjob Nord übernimmt die Vorauswahl und stellt passende Kandidaten vor.
            </p>
            <ul className="space-y-3">
              {[
                'Schnelle Personalvermittlung im Norden',
                'Vorauswahl nach Verfügbarkeit und Tätigkeit',
                'Weniger Aufwand bei der Bewerbersuche',
                'Geeignet für einfache & wiederkehrende Tätigkeiten'
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-slate-200 flex items-center justify-center text-slate-700 flex-shrink-0">
                    <SafeIcon icon={FiCheck} className="text-xs" />
                  </span>
                  <span className="text-slate-700">{item}</span>
                </li>
              ))}
            </ul>
            <div className="pt-4">
              <Link to="/unternehmen" className="btn-secondary group">
                Personalbedarf anfragen
                <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative rounded-2xl overflow-hidden aspect-square md:aspect-[4/3] shadow-2xl"
          >
            {/* IMAGE: Attraktive Frau im Reinigungsservice */}
            <img 
              src="https://images.unsplash.com/photo-1584622781564-1d987f7333c1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" 
              alt="Frau im Reinigungsservice" 
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default FeaturesSplit;